import { fetchJSON } from '@bonnet/next/fetch';

export default async function fetchFdpqMakeList(dealerId) {
    let fdpqMakeList = [];

    try {
        if (dealerId) {
            fdpqMakeList = await fetchJSON('/car-dealers/fdpq/makelist', {
                search: {
                    leadPartnerFranchiseId: dealerId,
                    leadFranchiseId: dealerId,
                },
                circuitBreaker: {
                    timeout: 3000,
                    fallback: [],
                    id: 'fdpq_make_list',
                },
            });
        }
    } catch (error) {
        console.log('fetchFdpqMakeList error:', error);
    }

    return fdpqMakeList;
}
